import React, { useEffect, useState } from 'react';
import Columns from '@/components/Columns';
import Column from '@/components/Column';
import Button from '@/components/Button';
import Text from '@/components/Text';
import './styles.css';
import { usePaymentMethodChangedStore } from '@/store/paymentMethodChanged';

type ForceChangePaymentMethodProps = {
  setShowForceChangePaymentMethod(value: boolean): void;
  setUserSaidThatDontWantToChange(value: boolean): void;
  changeMethod(): void;
  method: string;
};

const ForceChangePaymentMethodAlert: React.FC<
  ForceChangePaymentMethodProps
> = ({ setShowForceChangePaymentMethod, changeMethod, method, setUserSaidThatDontWantToChange }) => {
  const setPaymentMethodHasAlreadyBeChanged = usePaymentMethodChangedStore(
    (store) => store.setPaymentMethodHasAlreadyBeChanged,
  );
  const setShouldUpdateSale = usePaymentMethodChangedStore(
    (store) => store.setShouldUpdateSale,
  );
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);
  return (
    <div
      className={`alert-force-credit-card-container flex items-center justify-center ${
        show ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <Columns
        as='aside'
        className='mx-6 flex max-w-xs flex-col items-center justify-center rounded-lg bg-white p-5 lg:m-0'
        useNegativeMargin={false}
      >
        <Text as='h1' kind='blue' size='2xl' className='font-bold'>
          Compra não finalizada
        </Text>
        <Column className='itens-center flex flex-col justify-between'>
          <Text as='h3' kind='gray' size='base' className='p-2 text-center'>
            Não foi possível finalizar a compra utilizando a forma de pagamento
            escolhida.
          </Text>
          <Text as='h3' kind='gray' size='base' className='p-2 text-center'>
            Mas não se preocupe, o plano que você escolheu está{' '}
            <strong>disponível</strong> para pagamentos via{' '}
            <strong>{method}</strong>. Deseja trocar a forma de pagamento?
          </Text>
          <Column className='px-5 pt-2'>
            <Button
              kind='secondary'
              large
              onClick={() => {
                setShouldUpdateSale(true);
                setShowForceChangePaymentMethod(false);
                setUserSaidThatDontWantToChange(true);
              }}
            >
              Não desejo trocar
            </Button>

            <Button
              kind='primary'
              large
              onClick={() => {
                changeMethod();
                setShouldUpdateSale(true);
                setShowForceChangePaymentMethod(false);
                setPaymentMethodHasAlreadyBeChanged(true);
              }}
            >
              Trocar
            </Button>
          </Column>
        </Column>
      </Columns>
    </div>
  );
};

export default ForceChangePaymentMethodAlert;
